'use client';

import classnames from 'classnames';

import { DropDownItem } from './DropDown';

import styles from '../plugins/ToolbarPlugin.module.scss';

type DropdownMenuItemProps = {
  onClick: () => void;
  active?: boolean;
  iconClassName: string | string[];
  label: string;
  className?: string;
};

export function DropdownMenuItem({
  onClick,
  active = false,
  iconClassName,
  label,
  className,
}: DropdownMenuItemProps) {
  const iconClasses = Array.isArray(iconClassName)
    ? iconClassName
    : [iconClassName];

  return (
    <DropDownItem
      onClick={onClick}
      className={classnames(
        styles['block-type-item'],
        active && styles['active'],
        className,
      )}
    >
      <div className={styles['icon-text-container']}>
        <i className={classnames(styles['format'], ...iconClasses)} />
        <span className={styles['text']}>{label}</span>
      </div>
    </DropDownItem>
  );
}
